import { useRef, useEffect } from 'react';

/**
 * A hook to return the previous value of a variable on each render
 * @param {*} value The value to track
 * @returns {*} The previous value
 */

var usePreviousValue = function usePreviousValue(value) {
  var prev = useRef();
  useEffect(function () {
    prev.current = value;
    return function () {
      prev.current = undefined;
    };
  });
  return prev.current;
};

var usePreviousValue$1 = usePreviousValue;

export { usePreviousValue$1 as default };
